const language = {
	spanish: {
		soporte_yellow_title: "SOPORTE",
		acceso_bold_title: "Acceso a Jira Atlassian",
		acceso_bold_text: "Accede a tu gestión de proyecto en Jira",
		acceso_text: "Acceso exclusivo para nuestros clientes",
		button_content: "ACCEDER A JIRA",
		route: "Inicio / Recursos / Centro de Soporte",
	},
	english: {
		soporte_yellow_title: "SUPPORT",
		acceso_bold_title: "Access to Jira Atlassian",
		acceso_bold_text: "Access your project management in Jira",
		acceso_text: "Exclusive access for our customers",
		button_content: "ACCESS JIRA",
		route: "Home / Resources / Support Center",
	},
};

export default language